import React from 'react';
import { t } from '../i18n';

export default function Footer({ lang }) {
  const c = t(lang);
  const year = new Date().getFullYear();

  const legal = [
    { label: c.footer.terms, href: '/terms.html' },
    { label: c.footer.privacy, href: '/privacy.html' },
    { label: c.footer.notice, href: '/notice.html' },
    { label: c.footer.disclaimer, href: '/disclaimer.html' },
  ];

  return (
    <footer className="bg-[#062828] text-teal-100/80 pt-16 pb-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-14">
          <div>
            <a href="/" className="inline-flex items-baseline gap-1 mb-4">
              <span className="font-display text-xl font-bold text-white">DigiSpace</span>
              <span className="font-display text-xl font-bold text-teal-300">Prime</span>
            </a>
            <p className="text-sm leading-relaxed text-teal-100/55 max-w-sm">{c.footer.about}</p>
          </div>

          <div>
            <p className="font-display text-sm font-bold text-white uppercase tracking-wider mb-4">
              {c.footer.transparency}
            </p>
            <nav className="flex flex-col gap-2.5">
              {legal.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm hover:text-teal-200 transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <p className="font-display text-sm font-bold text-white uppercase tracking-wider mb-4">
              {c.footer.contact}
            </p>
            <p className="text-sm mb-1">
              <a href={`tel:+525547426486`} className="hover:text-teal-200">
                {c.footer.phone}
              </a>
            </p>
            <p className="text-sm text-teal-100/55 mb-3">{c.footer.hours}</p>
            <a
              href={`mailto:${c.footer.email}`}
              className="text-sm text-teal-300 hover:text-white transition-colors"
            >
              {c.footer.email}
            </a>
          </div>
        </div>

        <div className="border-t border-teal-800/50 pt-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-teal-100/40">
          <p>
            © {year} DigiSpace Prime
          </p>
          <p>{c.footer.support}</p>
        </div>
      </div>
    </footer>
  );
}
